import React from 'react';
import styled from 'styled-components';

const TitleContainer = styled.div`
  text-align: center;
`;

const Tecneps = styled.h1`
  left: 40px;
  font-weight: 900;
  font-family: Public Sans;
  font-size: 50px;
  position: fixed;
  top: 112px;
  color: #6AB8A8;
`;

const Subtitle = styled.h1`
  font-size: 14px;
  line-height: 1;
  font-family: Public Sans;
  position: fixed;
  font-weight: 800;
  left: 40px;
  top: 172px;
  color: #6AB8A8;
`;

const ModuleTitle = styled.h1`
  font-size: 10px;
  font-weight: bold;
  font-family: Public Sans;
  position: fixed;
  left: 30px;
  top: 222px;
  color: #FF9F1F;
  border-style: solid;
  border-radius: 10px;
  padding: 11px 20px 11px 20px;
  display: inline-block;
  border-width: 2px;
`;

const TitleModule = () => {
  return (
    <TitleContainer>
      <Tecneps>TECNEPS</Tecneps>
      <Subtitle>
        Tecnologia de Gestão para Núcleos
        <br />
        de Educação Permanente em Saúde
      </Subtitle>
      <ModuleTitle>MÓDULO ATIVIDADES PRÁTICAS / ESTÁGIOS</ModuleTitle>
    </TitleContainer>
  );
};

export default TitleModule;
